import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-left text-h6 text-left mb-1" }
const _hoisted_2 = { class: "d-flex flex-wrap align-left ga-2 mb-3 justify-center" }
const _hoisted_3 = { class: "d-flex flex-wrap align-left ga-2 mb-3 justify-center" }
const _hoisted_4 = { class: "d-flex flex-wrap align-left ga-2 justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _directive_motion_slide_right = _resolveDirective("motion-slide-right")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_alert, {
    delay: 2500,
    border: "start",
    "close-label": "Hinweis schließen",
    color: "blue-darken-2",
    title: "Hinweis zur Präsentation",
    variant: "tonal",
    closable: "",
    class: "position-fixed",
    style: {"top":"100px","right":"16px","z-index":"999","max-width":"450px"},
    clearable: ""
  }, {
    default: _withCtx(() => [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-body-1 text-left mb-2" }, " Bitte lade nur Präsentationen hoch, die keine Gliederungsfolien, keine automatischen Layout-Hooks und Overlay-Befehle enthalten. ", -1)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          size: "x-small",
          color: "red-darken-4",
          class: "mr-2 mt-1"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("mdi-block-helper")
          ])),
          _: 1,
          __: [0]
        }),
        _cache[1] || (_cache[1] = _createTextVNode(" Nicht unterstützte Befehle: "))
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-subtitle-2 font-weight-medium mb-1" }, "1. Gliederungs- und Titelfolien", -1)),
      _cache[21] || (_cache[21] = _createElementVNode("div", {
        class: "text-body-2 text-left mb-1",
        style: {"max-width":"450px"}
      }, [
        _createTextVNode(" Diese Befehle werden aktuell "),
        _createElementVNode("strong", null, "nur erkannt "),
        _createTextVNode(", wenn sie sich "),
        _createElementVNode("strong", null, "innerhalb einer Frame-Umgebung"),
        _createTextVNode(" befinden. ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("code", null, "\\titlepage", -1)
          ])),
          _: 1,
          __: [2]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("code", null, "\\partpage", -1)
          ])),
          _: 1,
          __: [3]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("code", null, "\\sectionpage", -1)
          ])),
          _: 1,
          __: [4]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("code", null, "\\subsectionpage", -1)
          ])),
          _: 1,
          __: [5]
        })
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-subtitle-2 font-weight-medium mb-1" }, "2. Automatische Folien (Präambel-Hooks)", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("code", null, "\\AtBeginPart", -1)
          ])),
          _: 1,
          __: [6]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createElementVNode("code", null, "\\AtBeginSection", -1)
          ])),
          _: 1,
          __: [7]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createElementVNode("code", null, "\\AtBeginSubsection", -1)
          ])),
          _: 1,
          __: [8]
        })
      ]),
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-subtitle-2 font-weight-medium mb-1" }, "3. Overlay- und Animationsbefehle", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createElementVNode("code", null, "\\pause", -1)
          ])),
          _: 1,
          __: [9]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createElementVNode("code", null, "\\onslide", -1)
          ])),
          _: 1,
          __: [10]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createElementVNode("code", null, "\\only", -1)
          ])),
          _: 1,
          __: [11]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createElementVNode("code", null, "\\uncover", -1)
          ])),
          _: 1,
          __: [12]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [
            _createElementVNode("code", null, "\\visible", -1)
          ])),
          _: 1,
          __: [13]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createElementVNode("code", null, "\\invisible", -1)
          ])),
          _: 1,
          __: [14]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createElementVNode("code", null, "\\alt", -1)
          ])),
          _: 1,
          __: [15]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [
            _createElementVNode("code", null, "\\temporal", -1)
          ])),
          _: 1,
          __: [16]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createElementVNode("code", null, "\\againframe", -1)
          ])),
          _: 1,
          __: [17]
        }),
        _createVNode(_component_v_chip, {
          color: "red-darken-4",
          size: "small",
          label: ""
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [
            _createElementVNode("code", null, "\\overlayarea", -1)
          ])),
          _: 1,
          __: [18]
        })
      ]),
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "pt-5 text-left font-weight-bold mb-2" }, " Diese Befehle werden aktuell nicht unterstützt und können zu unerwarteten Ergebnissen führen!! ", -1))
    ]),
    _: 1,
    __: [19,20,21,22,23,24]
  })), [
    [_directive_motion_slide_right]
  ])
}